import male from '@/assets/DefaultCloudzet/HomePage/rectangle_male.svg';
import female from '@/assets/DefaultCloudzet/HomePage/rectangle_female.svg';

const showAvatar = {
  data: () => ({
    newAvatarPreview: '',
  }),
  computed: {
    avatarSrc() {
      if (this.newAvatarPreview) return this.newAvatarPreview;

      const { avatar_thumb_url: avatar, gender } = this.profile;
      if (avatar && avatar.indexOf('ic_customer_photo') < 0) return avatar;

      return gender === 1 ? male : female;
    },
  },
};

export default showAvatar;
